import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Toast text (guide 7.12): ui size, text-primary, 16px semantic icon on the left. */
export const SuccessTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  ...theme.typography.body2,
  color: theme.palette.text.primary,
  '& span': { color: theme.palette.tokens.color.positive, fontSize: '18px' },
}));

export const ErrorTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  ...theme.typography.body2,
  color: theme.palette.text.primary,
  '& span': { color: theme.palette.tokens.color.negative, fontSize: '18px' },
}));

/** Surface toast: bottom-left, 360px max, hairline, float shadow. */
export const toastSx = {
  '.MuiSnackbarContent-root': {
    minWidth: '280px',
    maxWidth: '360px',
    backgroundColor: 'var(--surface)',
    color: 'var(--text-primary)',
    border: '1px solid var(--border-hairline)',
    borderRadius: 'var(--r-card)',
    boxShadow: 'var(--shadow-float)',
    padding: '10px 16px',
  },
} as const;
